import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {AssetLien} from '../../../shared/domain/item';

@Component({
  selector: 'lib-item-summary-asset-lien-card',
  templateUrl: './asset-lien-card.component.html',
  styleUrls: ['./asset-lien-card.component.scss']
})
export class AssetLienCardComponent implements OnInit {

  @Input() item: AssetLien;
  @Input() canModifyLiens: boolean;
  @Input() isLienEditable: boolean;

  @Output() onEditLien = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  public editLien() {
    this.onEditLien.emit(this.item);
  }

}
